<template>
  <!-- 外发管理 -->
  <div class="container">
    <!-- 按钮列表 -->
    <div class="glo_btnList" ref="btnList">
      <div class="glo_btnList_left">
        <el-dropdown class="topDropDown" @command="topCommandBtns">
          <el-button type="primary">
            更多操作
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="jtdc">导出</el-dropdown-item>
            <el-dropdown-item command="bgsz">表格设置</el-dropdown-item>
            <!-- <el-dropdown-item command="print_btn">打印</el-dropdown-item> -->
          </el-dropdown-menu>
        </el-dropdown>
      </div>

      <queryBtns :MoreConditions="MoreConditions" :showMoreBtns="true" @clerBtns="clerBtns" @queryBtn_ok="queryBtn_ok" @moreParam="moreParam"></queryBtns>
    </div>
    <!-- 查询条件 -->
    <div ref="queryForm">
      <el-form :model="queryData" :class="isHaseMore ? 'glo_form hasMoreParam' : 'glo_form'" label-position="left">
        <!-- 时间组件 -->
        <el-form-item class="queryItemsTimes">
          <multitime :timeType="timeType" :timeTypes="timeTypes" :startTime="startTime_a" :endTime="endTime_a" @timestatus="timestatus" @queryBtn_ok="queryBtn_time"></multitime>
        </el-form-item>
      </el-form>
    </div>
    <!-- 表格 -->
    <div class="glo_Table">
      <el-table
        :height="tableHeigth"
        header-align="center"
        ref="mytable"
        @row-click="rowclick"
        :data="tableData"
        border
        stripe
        :highlight-current-row="true"
        show-summary
        :summary-method="getSummaries"
        @selection-change="handleSelectionChange"
      >
        <el-table-column fixed="left" align="center" label="序号" type="index" width="60"></el-table-column>
        <el-table-column fixed="left" align="center" type="selection" width="60"></el-table-column>
        <template v-for="(item, index) in myTableHeard">
          <!-- 某个字段需要单独操作  例如点击可以跳转 -->
          <el-table-column
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
            v-if="item && item.isShow"
          ></el-table-column>
        </template>
        <template v-for="(itemp, indexp) in expandKey">
          <!-- item.fieldKey -->
          <el-table-column :label="itemp.parentFieldKeyShow" :key="itemp.parentFieldKey">
            <!-- :prop="item.fieldKey" -->
            <el-table-column  :label="item.fieldKeyShow" width="120" v-for="(item, index) in itemp.child" :key="item.fieldKey">
              <template slot-scope="scope">
                <span>{{ scope.row.expandVals[item.fieldKey] }}</span>
              </template>
            </el-table-column>
          </el-table-column>
        </template>
      </el-table>
    </div>

    <!-- 分页 -->
    <paging ref="pags" :pageNum="pageStart" :total="pageCount" :size="pageTotal" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange"></paging>
    <!--        自定义表头           -->
    <sorttable
      :show_sortTableHeard="show_sortTableHeard"
      :allCheck="allCheck"
      :sortName="sortName"
      :tabelHeadeTitle="tabelHeadeTitle"
      :originalTabelHeadeTitle="originalTabelHeadeTitle"
      :selectLength="selectLength"
      @cancelSortHeard="cancelSortHeard"
      @confirmOk="confirmOk"
      @checktab="checktab"
      @checkAll="checkAll"
      @closeDias="closeDias"
    ></sorttable>

    <prints
      :diaWidth_print="diaWidth_print"
      :dialogTitle_print="dialogTitle_print"
      :isShowDialog_print="isShowDialog_print"
      :dataList="dataList"
      :topData="topData"
      @handleCloseDia_print="handleCloseDia_print"
      @diaConfirmBtn_print="diaConfirmBtn_print"
    ></prints>

    <!-- 选择打印模板 -->
    <printDialog
      :dialogFrom="dialogFrom"
      ref="dialogSelect"
      title="选择模板"
      icon="el-icon-printer"
      modelTypeVal="异常表-客户 打印模板"
      @handleCreated="handleCreated"
      @handleView="handleView"
      @handleEdit="handleEdit"
      @handleOk="handleOk"
    ></printDialog>

    <!-- 创建和使用模板 -->
    <printSys :printForm="printForm" :title="printTitle" icon="el-icon-printer" @handleClose="handlePrintSysClose">
      <printSysContent :printType="printType" :modelObj="modelObj" :modelClassName="modelClassName" :selectTableData="selectTableData"></printSysContent>
    </printSys>

    <!-- 打印系统数据接口的className -->
    <classNameDialog
      :diaWidth="classNameDiaWidth"
      :dialogTitle="classNameDialogTitle"
      :isShowDialog="isShowClassNameDialog"
      @handleCloseDia="handleCloseClassNameDia"
      @diaCancelBtn="classNameDiaCancelBtn"
      @diaConfirmBtn="classNameDiaConfirmBtn"
    >
      <el-select v-model="modelClassName" placeholder style="width: 100%">
        <el-option v-for="(value, key) in classNameArr" :key="key" :label="value.name" :value="value.val"></el-option>
      </el-select>
    </classNameDialog>

    <!-- 导出插件 -->
    <exportCompoent
      :isShowDialog_dc="isShowDialog_dc"
      :diaWidth_dc="diaWidth_dc"
      :dialogTitle_dc="dialogTitle_dc"
      :dialogForm_dc="dialogForm_dc"
      :tableHeard="EPtableHeard"
      :AllCheck="EPAllCheck"
      @checktabEP="checktabEP"
      @checkAllEP="checkAllEP"
      @onAfterEnter="onAfterEnter"
      @handleCloseDia_dc="handleCloseDia_dc"
      @diaConfirmBtn_dc="diaConfirmBtn_dc()"
      :ddisShow='false'
    >
      <!-- 当前页面的查询条件 -->
      <div ref="queryForm">
        <el-form :model="queryData" class="glo_form hasMoreParam" label-position="left">
          <!-- 时间组件 -->
          <el-form-item class="queryItemsTimes">
            <multitime :timeType="timeType" :timeTypes="timeTypes" :startTime="startTime_a" :endTime="endTime_a" @timestatus="timestatus" @queryBtn_ok="queryBtn_time"></multitime>
          </el-form-item>
        </el-form>
      </div>
    </exportCompoent>
  </div>
</template>
<script>
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import paging from "@/components/pagings.vue"; //分页组件
import multitime from "@/components/multiTime.vue";
import myDialog from "@/components/Dialog.vue";
import classNameDialog from "@/components/Dialog.vue";
import queryBtns from "@/components/queryBtns.vue";
import prints from "@/components/prints/print_waiFa.vue";
import printDialog from "@/components/printDialog/index.vue";
import printSys from "@/components/printSys/index.vue";
import printSysContent from "@/components/printSys/content.vue";
import { hiprint } from "@/print.js";
import exportjs from "@/assets/js/Mixins/export.js"; //导出的公共js

export default {
  mixins: [exportjs],
  inject: ["reload"],
  components: {
    sorttable,
    paging,
    multitime,
    myDialog,
    queryBtns,
    prints,
    printDialog,
    printSys,
    printSysContent,
    classNameDialog,
  },
  data() {
    return {
      expandKey: [],
      //=======================导出相关 开始 =======================
      dialogForm_dc: {
        pageStart: 1,
        pageTotal: "",
        fileName: "异常总表",
        apiName: "/admin/v3/exception/getCustomerExceptionList", //导出的数据列表接口名
        EpType: "bdd", //dd==等待下载完成,bdd==不等待完成
        apiType: "POST", //导出当前列表的请求方式
        pageType: "BusinessOrder_ExceptionManage_AbnormalTableCustomers", //页面类型(主要用来区分查询参参数的时间)
      },
      //=======================导出相关 结束 =======================
      // 打印预览
      isShowDialog_print: false,
      diaWidth_print: "90%",
      dialogTitle_print: "打印预览",
      dataList: [],
      topData: {},

      changeCarrierList: [],
      storageList: [],
      //  -----  查询  ------
      queryData: {
        startTakeTime: "",
        endTakeTime: "",
        customerId: "",
      }, //  表单查询数据
      //  时间类型
      timeTypes: [
        {
          value: "0",
          label: "提货日期",
        },
      ],
      timeType: "0", //  时间类型
      startTime_a: "",
      endTime_a: "",

      MoreConditions: "更多条件", //  输入框绑定动态class
      isHaseMore: false, //false == 更多条件  true ==收起条件

      //      -------  表格  ----------
      pageStart: 1, //  页码
      pageCount: 0, //  总条数
      pageTotal: this.$COMMON.pageTotals, //  一页几条
      tableHeigth: "75vh", //  表格高度
      selectTableData: [], //  表格选中的数据

      show_sortTableHeard: false, //显示表格设置弹窗
      // 默认表头
      tabelHeadeTitle: [
        {
          name: "日期",
          field: "dateStr",
          width: "160",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "日运输票数",
          field: "waybillCount",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "件数",
          field: "packageCount",
          width: "150",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },

        {
          name: "重量",
          field: "weight",
          width: "160",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "异常",
          field: "exceptionCount",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "达标率",
          field: "complianceRate",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        // {
        //   name: "质量（异常类型）",
        //   field: "complianceRate",
        //   width: "110",
        //   sort: 1,
        //   isShow: true, //是否展示
        //   isTotal: false, //是否开启合计
        //   isSort: true, //表格设置里面是否可以排序
        // },
        // {
        //   name: "交期（异常类型）",
        //   field: "complianceRate",
        //   width: "110",
        //   sort: 1,
        //   isShow: true, //是否展示
        //   isTotal: false, //是否开启合计
        //   isSort: true, //表格设置里面是否可以排序
        // },
        // {
        //   name: "服务（异常类型）",
        //   field: "complianceRate",
        //   width: "110",
        //   sort: 1,
        //   isShow: true, //是否展示
        //   isTotal: false, //是否开启合计
        //   isSort: true, //表格设置里面是否可以排序
        // },
      ],
      myTableHeard: [], //  我的表头
      originalTabelHeadeTitle: [], //自定义排序表头(恢复默认用)
      tableData: [], //  表格数据

      allCheck: false, //  全选
      sortName: "异常表-客户", //  排序名
      selectLength: 0, //  显示的长度

      totalArr: [], //  表格需要合计的字段
      className: "", //  导出需要
      pageGroupName: "BusinessOrder_ExceptionManage_AbnormalTableCustomers", //  页面标识

      fileNameLists: [], //上传组件的
      // ==== 弹窗组件属性 start ====
      isShowDialog: false,
      dialogTitle: "弹窗标题",
      diaWidth: "60%",
      classNameDiaWidth: "300px",
      classNameDialogTitle: "请选择className",
      isShowClassNameDialog: false,
      // ==== 弹窗组件属性 end ====

      // 打印模块
      // 打印弹出框
      dialogFrom: {
        dialogVisible: false,
      },
      // 创建新的打印
      printForm: {
        dialogVisible: false,
      },
      printTitle: "创建模板",
      printType: 1, // 1是创建 2是使用
      // 打印
      printDesignForm: {
        dialogVisible: false,
      },
      // 选择的模板数据
      modelObj: null,
      // 模板className
      classNameArr: [
        {
          name: "承运商结算单",
          val: "com.bami.service.tms.v3.admin.print.vo.AdminOutgoingPrintDataV3tmsVo",
        },
        {
          name: "批量打印标签",
          val: "com.bami.service.tms.v3.admin.print.vo.AdminOutgoingPrintBillDataV3tmsVo",
        },
      ],
      // 默认打印模板类型
      modelClassName:
        "com.bami.service.tms.v3.admin.print.vo.AdminOutgoingPrintDataV3tmsVo",
      // 下面是所有的模板类型
      modelClassName1:
        "com.bami.service.tms.v3.admin.print.vo.AdminOutgoingPrintDataV3tmsVo",
      modelClassName2:
        "com.bami.service.tms.v3.admin.print.vo.AdminOutgoingPrintBillDataV3tmsVo",

      CustomerLists: [],
    };
  },
  updated() {
    if (this.show_sortTableHeard) {
      // 排序表头
      let arr = this.tabelHeadeTitle;
      for (var i = 0; i < arr.length; i++) {
        arr[i].sort = i + 1;
      }
      this.tabelHeadeTitle = arr;
    }
  },
  created() {
    this.myTableHeard = this.tabelHeadeTitle;
    if (this.originalTabelHeadeTitle.length === 0) {
      this.originalTabelHeadeTitle = JSON.parse(
        JSON.stringify(this.tabelHeadeTitle)
      );
    }
    this.startTime_a = this.$TOOLS.getFlexDate(this.$COMMON.timeNum); //开始时间;
    this.endTime_a = this.$TOOLS.getCurrentDate(); //今天的时间;

    this.getData();
    //获取默认表头 页面有这四个字段 myTableHeard,sortName,tabelHeadeTitle,totalArr
    this.$TOOLS.getGroupFindFieldSort(this, this.pageGroupName);
  },
  activated() {
    // 每次进页面都会触发的写这里
    //计算获取表格高度
    // this.getData();
  },
  deactivated() {},
  mounted() {
    this.getCustomerList(); //  获取客户列表
  },
  watch: {},
  methods: {
    // 确定按钮
    diaConfirmBtn_dc() {
      let that = this
      // 暂时这样写,以后再改造成功动态查询条件的
      let param = that.queryData || {}

      param.pageStart = this.dialogForm_dc.pageStart
      param.pageTotal = this.dialogForm_dc.pageTotal
      param.fileName = this.dialogForm_dc.fileName
      // 导出(生成历史记录),只返回提示
      this.$API.exportCustomerExceptionList(param).then((res) => {
        this.$message.success('数据处理中,请到右上角导出记录中查询结果')
        setTimeout(() => {
          that.isShowDialog_dc = false
        }, 1000)
      })
    },
    // 获取客户列表
    getCustomerList(name) {
      this.$API
        .wtl_getObjectUserDownList({
          key: "customer",
          name: name || "",
          pageStart: 1,
          pageTotal: 200,
        })
        .then((res) => {
          this.CustomerLists = res.data.result.data || [];
        });
    },
    // 选择或者清除客户时触发
    changeCustomer(e) {
      if (!e) {
        this.getCustomerList();
      }
      this.queryBtn_ok();
    },
    handleCloseClassNameDia() {
      this.isShowClassNameDialog = false;
    },
    classNameDiaCancelBtn() {
      this.isShowClassNameDialog = false;
    },
    classNameDiaConfirmBtn() {
      // modelClassName
      if (!this.modelClassName) {
        this.$message.error("请选择className");
        return;
      }
      this.isShowClassNameDialog = false;
      setTimeout(() => {
        this.dialogFrom.dialogVisible = false;
        this.printTitle = "创建模板";
        this.printType = 1;
        this.modelObj = null;
        setTimeout(() => {
          this.printForm.dialogVisible = true;
        }, 300);
      }, 300);
    },
    // 打印系统关闭
    handlePrintSysClose() {
      if (this.$refs.dialogSelect) {
        this.$refs.dialogSelect.doSearch();
      }
    },
    // 打印弹出框创建
    handleCreated() {
      this.isShowClassNameDialog = true;
    },
    // 打印预览模板
    handleEdit(obj) {
      // this.dialogFrom.dialogVisible = false;
      this.printTitle = obj.modelName;
      this.printType = 2;
      this.modelObj = obj;
      setTimeout(() => {
        this.printForm.dialogVisible = true;
      }, 300);
    },
    // 打印预览模板
    handleView(obj) {
      console.log("obj", obj);
      let hiprintTemplate = new hiprint.PrintTemplate({
        template: JSON.parse(obj.content),
      });
      let idarr = [];
      for (let i = 0; i < this.selectTableData.length; i++) {
        idarr.push(this.selectTableData[i].outgoingId);
      }
      if (obj.className == this.modelClassName2) {
        this.$API
          .getOutgoingTabPrintData({
            outgoingIds: idarr,
          })
          .then((res) => {
            if (res.status == 200) {
              if (res.data && res.data.status == "success") {
                const result = res.data.result;
                hiprintTemplate.print(result, {});
              }
            }
          });
      } else if (obj.className == this.modelClassName1) {
        this.$API
          .getOutgoingPrintData({
            outgoingIds: idarr,
          })
          .then((res) => {
            if (res.status == 200) {
              if (res.data && res.data.status == "success") {
                const result = res.data.result;
                hiprintTemplate.print(result, {});
              }
            }
          });
      }
    },
    // 确定模板的数据
    handleOk(obj) {
      let hiprintTemplate = new hiprint.PrintTemplate({
        template: JSON.parse(obj.content),
      });
      let idarr = [];
      for (let i = 0; i < this.selectTableData.length; i++) {
        idarr.push(this.selectTableData[i].outgoingId);
      }
      if (obj.className == this.modelClassName2) {
        this.$API
          .getOutgoingTabPrintData({
            outgoingIds: idarr,
          })
          .then((res) => {
            if (res.status == 200) {
              if (res.data && res.data.status == "success") {
                const result = res.data.result;
                hiprintTemplate.print(result, {});
              }
            }
          });
      } else {
        this.$API
          .getOutgoingPrintData({
            outgoingIds: idarr,
          })
          .then((res) => {
            if (res.status == 200) {
              if (res.data && res.data.status == "success") {
                const result = res.data.result;
                hiprintTemplate.print(result, {});
              }
            }
          });
      }
    },

    // 打印
    printEvent(row) {
      if (this.selectTableData.length < 1) {
        this.$message.error("请选择需要打印的外发单");
        return false;
      }
      let idarr = this.selectTableData.map((item) => {
        return item.outgoingId;
      });
      window.sessionStorage.setItem(
        "set_PrintSelectTableData",
        JSON.stringify(idarr)
      );
      this.dialogFrom.dialogVisible = true;
    },

    // 打印相关的
    handleCloseDia_print() {
      this.isShowDialog_print = false;
    },
    // 打印预览确定
    diaConfirmBtn_print() {
      this.isShowDialog_print = false;
    },
    // 打印相关的

    /***
     * ====== 弹窗组件方法 ======
     */
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia() {
      this.isShowDialog = false;
    },
    //  弹窗确认保存事件
    diaConfirmBtn() {
      this.isShowDialog = false;
    },
    //  关闭弹窗按钮事件(关闭按钮)
    diaCancelBtn() {
      this.isShowDialog = false;
    },

    // 时间组件 选择时间后触发
    queryBtn_time(s, e) {
      this.startTime_a = s || "";
      this.endTime_a = e || "";
      this.queryBtn_ok();
    },
    // 时间组件 选择类型后触发
    timestatus(type, s, e) {
      this.timeType = type || "0";
      this.startTime_a = s || "";
      this.endTime_a = e || "";
      this.queryBtn_ok();
    },

    handleSelectionChange(e) {
      // 表格选择事件
      this.selectTableData = e;
    },
    // 点击选中当前行
    rowclick(row, event, column) {
      this.$refs.mytable.toggleRowSelection(row);
    },
    getData() {
      let startTakeTime = "";
      let endTakeTime = "";
      let startTime = this.startTime_a ? this.startTime_a + " 00:00:00" : "";
      let endTime = this.endTime_a ? this.endTime_a + " 23:59:59" : "";

      if (this.timeType == "0") {
        startTakeTime = startTime;
        endTakeTime = endTime;
      }

      let param = this.queryData;
      param.startTakeTime = startTakeTime;
      param.endTakeTime = endTakeTime;
      param.pageStart = this.pageStart;
      param.pageTotal = this.pageTotal;

      this.$API.getCustomerExceptionList(param).then((res) => {
        if (res.data.status === "success") {
          this.className = res.data.result.className || "";
          let arrs = res.data.result.data || [];
          // arrs.forEach(element => {

          // });
          this.tableData = arrs;
          this.pageCount = res.data.result.pageCount || 0;
          let resData = res.data.result.expandKey || [];
          let dataInfo = {};
          resData.forEach((item, index) => {
            let { parentFieldKey, parentFieldKeyShow } = item;
            if (!dataInfo[parentFieldKey]) {
              dataInfo[parentFieldKey] = {
                parentFieldKey,
                parentFieldKeyShow,
                child: [],
              };
            }
            dataInfo[parentFieldKey].child.push(item);
          });
          this.expandKey = Object.values(dataInfo);
          this.$nextTick(() => {
            this.fetTableHeight();
          });
        } else {
          this.$message.error(`${res.data.message}---综合查询列表`);
        }
      });
    },

    queryBtn_ok() {
      //  查询按钮
      this.pageStart = 1;
      this.getData();
    },

    clerBtns() {
      //  重置按钮
      this.queryData = {
        endCreateTime: "",
        endOutgoingTime: "",
        outboundCarrierId: "",
        outgoingNumber: "",
        startCreateTime: "",
        startDeptId: "",
        startOutgoingTime: "",
        waybillNumber: "",
        isPosting: 0,
        isExpense: "",
        settlementMethodConfDictId: "",
      };
    },

    moreParam() {
      this.isHaseMore = !this.isHaseMore;
      if (this.isHaseMore) {
        this.MoreConditions = "收起条件";
      } else {
        this.MoreConditions = "更多条件";
      }

      this.$nextTick(() => {
        this.fetTableHeight();
      });
    },

    handleSizeChange(val) {
      //  分页
      this.pageTotal = val;
      this.getData();
    },
    handleCurrentChange(val) {
      //  分页
      this.pageStart = val;
      this.getData();
    },
    // 点击导出 (页面标识,表头,列表标识,数据源,表名)
    exportBtn() {
      this.$COMAPI.exportBtn({
        pageGroupName: this.pageGroupName, //页面标识
        myTableHeard: this.myTableHeard, //表头数组
        className: this.className, //列表标识
        tableData: this.tableData, //数据源
        sheetName: "表名(暂无效)", //表名
      });
    },

    // 表格合计
    getSummaries(param) {
      let that = this;
      const { columns, data } = param;

      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        for (var i = 0; i < that.totalArr.length; i++) {
          if (column.property === that.totalArr[i]) {
            if (!values.every((value) => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return this.$TOOLS.mathToFixed(
                    this.$TOOLS.add(prev, curr),
                    2
                  );
                } else {
                  return prev;
                }
              }, 0);
              sums[index] += "";
            } else {
              sums[index] = "---";
            }
          }
        }
      });
      this.$nextTick(() => {
        this.$refs.mytable.doLayout();
      });
      return sums;
    },

    /***
     * ==============设置表格动态高度==============
     */
    fetTableHeight() {
      // 重置table高度
      this.tabelHeigth = 0;
      // 设置table高度
      let windonHeight =
        document.body.clientHeight || document.documentElement.clientHeight; //页面高度
      let queryHeigth = 40 + 10; //10==margin-top: 10  查询框高度
      let btnListHeight = this.$refs.btnList.offsetHeight; // 按钮列表高度
      if (this.isHaseMore) {
        queryHeigth = this.$refs.queryForm.offsetHeight + 10; //查询框
      }
      let pagsHeigth = 40 + 20; //分页组件高度 20是上下margin
      var otherHeight = queryHeigth + btnListHeight + pagsHeigth + 60; //60是顶部导航 10是
      let tabHeight = Math.floor(windonHeight - otherHeight) || ""; //

      this.$nextTick(() => {
        this.tableHeigth = tabHeight;
        this.$refs.mytable.doLayout();
      });
    },

    /****
     *  ===================下面页面公共方法 start ===================
     *
     */

    //顶部跟多按钮的操作
    topCommandBtns(a) {
      if (a === "bgsz") {
        // 设置模板按钮
        // this.myModel();
        this.$TOOLS.myModel(this);
      }
      if (a === "dyyd") {
        // 打印运单
      }
      if (a === "dy_a") {
        // 打印标签
        this.isShowDialog_print = true;
      }
      if (a === "print_btn") {
        this.printEvent();
      }
      // if (a === "dc") {
      //   // 导出
      //   this.exportBtn();
      // }
      if (a === "jtdc") {
        // 新版导出
        this.dialogForm_dc.pageTotal = this.pageTotal
        this.isShowDialog_dc = true;
      }
    },

    // =================== 排序表头彈窗的组件方法 start ===================
    //   取消按钮(表格设置)
    cancelSortHeard() {
      this.show_sortTableHeard = false;
      this.$nextTick(() => {
        this.$refs.mytable.doLayout();
      });
    },
    // 排序==>确认按钮(表格设置)
    confirmOk(e) {
      this.tabelHeadeTitle = e;
      this.myTableHeard = this.tabelHeadeTitle;
      let sortObject = this.myTableHeard;
      let param = {
        groupName: this.pageGroupName, //当前页面表格的标记(自定义字符串)
        sortName: this.sortName, //综合查询接口路径
        sortObject: JSON.stringify(sortObject),
      };
      this.$API.pushFindFieldSort(param).then((res) => {
        this.$message.success(res.data.message || "操作成功");
        //获取默认表头
        this.$TOOLS.getGroupFindFieldSort(this, this.pageGroupName);
      });
      this.show_sortTableHeard = false; //关闭弹窗
      this.$nextTick(() => {
        this.$refs.mytable.doLayout();
      });
      this.show_sortTableHeard = false;
    },
    // 点击某一项(表格设置)
    checktab(idx, e) {
      let that = this;
      that.tabelHeadeTitle[idx].isShow = e;
      let selectLength = 0;
      for (var i = 0; i < that.tabelHeadeTitle.length; i++) {
        if (that.tabelHeadeTitle[i].isShow) {
          selectLength++;
        }
      }
      that.selectLength = selectLength;
      if (selectLength == that.tabelHeadeTitle.length) {
        that.allCheck = true;
      } else {
        that.allCheck = false;
      }
    },
    //全选(表格设置)
    checkAll(e) {
      let that = this;
      this.allCheck = e;
      for (var j = 0; j < this.tabelHeadeTitle.length; j++) {
        this.tabelHeadeTitle[j].isShow = e;
      }
      let selectLength = 0;
      for (var i = 0; i < that.tabelHeadeTitle.length; i++) {
        if (that.tabelHeadeTitle[i].isShow) {
          selectLength++;
        }
      }
      that.selectLength = selectLength;
    },
    //关闭弹窗(表格设置)
    closeDias(e) {
      this.show_sortTableHeard = e;
    },

    /****
     *  ===================排序表头彈窗的组件方法 end ===================
     *
     */
  },
};
</script>
<style scoped lang="less">
.tableBox {
  height: calc(100% - 260px);
}

.colorStyle {
  color: #f00;
}

.mdTitName {
  height: 24px;
  border: 1px solid #d7d7d7;
  text-align: center;
  min-width: 100px;
}

.queryCriteria {
  .queryItem_one {
    .queryTextarea {
      border: 1px solid #d7d7d7;
    }
  }

  .timeBox {
    border: 1px solid #d7d7d7;
  }
}

.headerboxs {
  width: 100%;
  padding: 5px 0;
  display: flex;
  align-items: center;
}

.iconInput {
  display: flex;
  align-items: center;
}
.mainCOlorBtns {
  background-color: #f0a261;
  color: #fff;
  border: none;
}
.mainCOlorBtns :hover {
  color: #fff;
}
</style>
